module.exports = __webpack_public_path__ + "static/img/gpt23.43f65d14.png";